import { TeamType } from '@aegislab/shared';

/** 화면이 쓰는 팀 종류 표시값. 서버 enum(`DEPARTMENT` 등)과 별개다. */
export type TeamTypeView = 'department' | 'task-force';

/**
 * 서버 팀 종류를 화면 표시값으로 바꾼다 — **이 변환의 유일한 정본**이다.
 *
 * 전에는 같은 변환이 **읽기 경로 4곳**에 복사돼 있었고 **기본값이 서로 반대**였다:
 * `entities/team/api/teamApi.ts` 3곳은 "`DEPARTMENT` 가 아니면 `task-force`",
 * `pages/HrManagementPage` 는 "`TASK_FORCE` 가 아니면 `department`".
 * 종류가 셋뿐이고 CLUB 은 상위에서 걸러지므로 **결과는 같았지만**, 네 번째 종류가 추가되면
 * 두 화면이 서로 다른 답을 내면서 아무 에러도 안 났다.
 *
 * **쓰기 경로는 여기 포함하지 않는다.** `widgets/team-ops/model/adapters/useManagementAdapter.ts`
 * 도 같은 모양으로 변환하지만 그건 서버로 보낼 payload 를 만드는 자리다 — 새 종류가 생겼을 때
 * 무엇을 보낼지는 화면에 무엇을 표시할지와 다른 판단이라 묶지 않는다.
 *
 * `switch` 로 종류를 하나씩 처리하므로, `TeamType` 에 값이 추가되면 반환 경로가 빠져
 * `noImplicitReturns` 가 **컴파일에서 막는다.** 사람이 5곳을 기억할 필요가 없어진다.
 *
 * 회귀 가드: `__tests__/toTeamTypeView.test.ts`.
 */
export function toTeamTypeView(type: TeamType): TeamTypeView {
  switch (type) {
    case TeamType.DEPARTMENT:
      return 'department';
    case TeamType.TASK_FORCE:
      return 'task-force';
    case TeamType.CLUB:
      // 동아리는 운영팀이 아니라 별도 화면(`features/club`)이 다룬다. 운영팀 목록을 만드는
      // 쪽(`getTeams` · `getMyTeams` · `fetchTeams`)이 전부 CLUB 을 먼저 걸러내므로 여기 오면
      // **그 필터가 빠진 것**이고, 반환값이 아니라 필터 부재가 버그다.
      // 값은 기존 다수 규칙과 같게 둬서 이 함수 도입 자체가 동작을 바꾸지 않게 한다.
      return 'task-force';
  }
}
